// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"~views/colors.css\"","easilBlue":"#3184fc","banner":"style_banner__1C3Tj","bannerText":"style_bannerText__3yPB-"};